import { useEffect, useState } from 'react';

interface Props {
  onDone: () => void;
  minDuration?: number;
}

const STAGES = [
  'Booting workflow engine',
  'Connecting to Storm Command',
  'Hydrating nodes',
  'Ready',
];

export function LoadingScreen({ onDone, minDuration = 1600 }: Props) {
  const [stage, setStage] = useState(0);
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const stageMs = minDuration / STAGES.length;
    const intervals: number[] = [];
    STAGES.forEach((_, i) => {
      const t = window.setTimeout(() => setStage(i), stageMs * i);
      intervals.push(t);
    });
    const fadeT = window.setTimeout(() => setFading(true), minDuration);
    const doneT = window.setTimeout(onDone, minDuration + 380);
    return () => {
      intervals.forEach(clearTimeout);
      clearTimeout(fadeT);
      clearTimeout(doneT);
    };
  }, [onDone, minDuration]);

  return (
    <div className={`loading-screen ${fading ? 'fade-out' : ''}`}>
      <div className="loading-eagle">
        <img
          src="https://jalenward.com/images/proposals/impactiq-white-400.png"
          alt="Impact IQ"
          onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
        <div className="loading-pulse-1" />
        <div className="loading-pulse-2" />
      </div>
      <div className="loading-headline">Workflow Builder</div>
      <div className="loading-eyebrow">Impact IQ · roofing intelligence</div>

      <div className="loading-bar">
        <div className="loading-bar-fill" style={{ width: `${((stage + 1) / STAGES.length) * 100}%` }} />
      </div>
      <div className="loading-stage">
        {STAGES[stage]}<span className="loading-dots"><i/><i/><i/></span>
      </div>
    </div>
  );
}
